import {makeAutoObservable} from 'mobx';

import type {Coach} from './types';

import {
  bitsToSchedule,
  SCHEDULE_SLOT_DURATION,
  scheduleToBits,
} from '../../utils/entity/user/schedule';
import {AsyncBusyManager, ListManager} from '../../utils/store';
import {chunkString} from '../../utils/string';
import {CoachModel} from './Coach.model';

export class CoachesStore {
  all: ListManager<CoachModel> = new ListManager();
  busy = new AsyncBusyManager();
  selectedIds: ListManager<string> = new ListManager(); // TODO: why???

  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  init(allCoaches: Coach[]) {
    this.all.resetEntries(allCoaches.map(c => new CoachModel(c)));
    this.selectedIds.resetEntries([this.all.entries[0]!.id]);
  }

  get bookingRange() {
    return this.selected[0]!.bookingRange;
  }

  get mergedScheduleForSelected() {
    if (this.selected.length === 1) {
      return this.selected[0]!.schedule;
    }

    const schedules = this.selected.map(coach =>
      scheduleToBits(coach.schedule),
    );

    const schedule = schedules[0]!.split('');

    const scheduleLen = schedule.length;
    const schedulesLen = schedules.length;

    for (let i = 0; i < scheduleLen; i++) {
      schedule[i] = new Array(schedulesLen)
        .fill('')
        .map((_, index) => schedules[index]![i]!)
        .every(item => item === '1')
        ? '1'
        : '0';
    }

    return bitsToSchedule(schedule.join(''));
  }

  get scheduleToTimeSlots() {
    const scheduleBits: string[] = chunkString(
      this.mergedScheduleForSelected,
      24,
    ).map(scheduleToBits);

    return scheduleBits.map(bits => {
      const dayTimes: string[] = [];
      const bitsLength = bits.length;

      for (let i = 0; i < bitsLength; i++) {
        let hour = 0;
        let minute = i * SCHEDULE_SLOT_DURATION;

        if (minute >= 60) {
          hour = Math.floor(minute / 60);
          minute = minute % 60;
        }

        dayTimes.push(`${hour}_${minute}`);
      }

      return dayTimes;
    });
  }

  get selected() {
    return this.all.filter(c => this.selectedIds.has(c.id));
  }

  onSelect(coachId: string) {
    // attention: change logic when multiple coach selection is available
    this.selectedIds.resetEntries([coachId]);
  }
}
